<template>
  <ReviewsBlock
    v-if="rates && !ratingError && !reviewsError"
    id="customer-reviews"
    :next-reviews-cursor="reviews?.nextCursor"
    :pending-summary="ratingSummaryPending"
    :previous-reviews-cursor="reviews?.previousCursor"
    :product-id="undefined"
    :rating="rates"
    :rating-summary
    :reviews="reviews?.results || []"
    :reviews-pending="pendingReviews"
  />
</template>

<script setup lang="ts">
import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'

import { useSellerRating } from '../../composables/useSellerRating'
import { useSellerRatingDetails } from '../../composables/useSellerRatingDetails'
import { useSellerReviews } from '../../composables/useSellerReviews'

const { data: rates, error: ratingError } = useSellerRating()
const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useSellerReviews()

const { data: ratingSummary, pending: ratingSummaryPending } =
  useSellerRatingDetails()
</script>
